<template>
  <!--子页面面板-->
  <div class="section-main__warp meeting-manage">
    <appCrudTab title="筛选面板">
      <template slot="form">
        <el-form :inline="true">
          <el-form-item label="标准名称">
            <el-input class="roomname-input" placeholder="请输入标准名称" v-model="standardName"></el-input>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="deviceType" placeholder="请选择">
              <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </appCrudTab>
    <!--数据面板-->
    <div style="
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        background: #fff;
        margin-top: 15px;
        padding: 0 15px;
      ">
      <div class="ioc-crud__table" style="flex: 1; display: flex; flex-direction: column; overflow-y: auto">
        <div class="mt-1 mb-1" style="margin: 10px 0">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </div>
        <el-table height="100%" ref="multipleTable" stripe :data="tableData" :row-key="getRowKey">
          <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
          <el-table-column prop="standardName" label="标准名称" align="center"></el-table-column>
          <el-table-column prop="deviceType" label="设备类型" align="center">
            <template slot-scope="scope">
              <span>{{ dealdeviceType(scope.row.deviceType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="standardRemarks" label="备注" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="编辑" placement="top-start">
                <i class="item-operation-icon iconfont icon-xiugai icon-blue" @click="handleEdit(scope.row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <i class="item-operation-icon el-icon-delete icon-blue" @click="deleteOne(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="meeting-footer">
      <el-pagination background @size-change="pageSizeChange" @current-change="pageNoChange" :current-page.sync="pageNo"
        :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <!-- <soc-data>
      <soc-table
        :columns="tableColumns"
        :data="tableData"
        :loading="tableLoading"
        :page-size="pageSize"
        :page-no="pageNo"
        :total="total"
        @pageNoChange="pageNoChange"
        @pageSizeChange="pageSizeChange"
      >
        <template #deviceType="{ row }">
          <span>{{ dealdeviceType(row.deviceType) }}</span>
        </template>
 
        <template #operating="{ row }">
          <div class="alarm_options">
            <i class="soc iconEdit options_icon" @click="handleEdit(row)" />
            <i class="soc iconDelete options_icon" @click="deleteOne(row)" />
          </div>
        </template>
      </soc-table>
    </soc-data> -->
    <add-standard-component v-if="addVisible" @handleCancel="handleCancel" @handleConfirm="handleConfirm" :title="title"
      :deviceTypeList="deviceTypeList" :form="standInfoForm" :standItemList="standItemList" />
  </div>
</template>

<script>
import AddStandardComponent from "@/modules/equipInspection/components/addStandardComponent";
import appCrudTab from "../components/app-crud-tab/index.vue";
import api from "../api/index";

export default {
  name: "standard",
  components: { AddStandardComponent, appCrudTab },
  data() {
    return {
      standInfoForm: {},
      standItemList: [],
      standardName: "",
      deviceType: "",
      deviceTypeList: [
        {
          label: '摄像机',
          value: '18'
        }
      ],
      addVisible: false,
      title: "",
      tableColumns: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "标准名称",
          prop: "standardName",
        },
        {
          label: "设备类型",
          prop: "deviceType",
        },
        {
          label: "备注",
          prop: "standardRemarks",
        },
        {
          label: this.$t("alarm.operatingLabel"),
          prop: "operating",
        },
      ],
      tableData: [],
      tableLoading: false,
      pageNo: 1,
      pageSize: 20,
      total: 0,
    };
  },
  mounted() {
    this.queryDeviceType();
    this.handleSearch();
  },
  methods: {
    getRowKey(row) {
      return row.meetingRoomId;
    },
    // 把设备类型转换成设备类型名字
    dealdeviceType(value) {
      let result = "";
      this.deviceTypeList.forEach((item) => {
        if (item.value == value) {
          result = item.label;
        }
      });
      return result;
    },
    // 获取设备类型getDeviceType
    queryDeviceType() {
      this.$fetch(api.standard.getDeviceType).then((res) => {
        this.deviceTypeList = res.returnObj.map((item) => {
          return {
            label: item.deviceTypeName || "",
            value: Number(item.deviceTypeId) || "",
          };
        });
      });
    },
    handleEdit(row) {
      this.title = "修改巡检标准";
      this.addVisible = true;
      this.queryStandardInfo(row);
      this.queryStandardItemList(row);
    },
    handleCancel() {
      this.addVisible = false;
    },
    handleAdd() {
      this.standItemList = [];
      this.standInfoForm = {};
      this.addVisible = true;
      this.title = "新增巡检标准";
    },
    /**
     * 获取巡检标准巡检项列表
     *
     */
    queryStandardItemList(row) {
      let url =
        api.standard.getStandardItemList + `?standardId=${row.standardId}`;
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.standItemList = res.data;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 获取巡检标准信息
     *
     */
    queryStandardInfo(row) {
      let url = api.standard.getStandardInfo + row.standardId;
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.standInfoForm = res.data;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 获取巡检列表
     */
    queryInspectionList() {
      this.tableLoading = true;
      let url =
        api.standard.getInspectionList +
        `?pageNo=${this.pageNo}&pageSize=${this.pageSize}`;
      if (this.standardName) {
        url += `&standardName=${this.standardName}`;
      }
      if (this.deviceType) {
        url += `&deviceType=${this.deviceType}`;
      }

      this.$fetchGet(url).then((res) => {
        this.tableLoading = false;
        if (res.success) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 删除单个标准
     */
    deleteOne(row) {
      this.$confirm("确认删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.handleDeleteStandard(row);
      }).catch(() => { });
    },
    /**
     * 删除单个的请求
     * @param userId 用户ID string
     */
    handleDeleteStandard(row) {
      let url = api.standard.delStandard + row.standardId;
      this.$fetchDelete(url).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
          this.handleSearch();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 记录信息查询
     */
    handleSearch() {
      this.pageNo = 1;
      this.queryInspectionList();
    },
    /**
     * 重置
     */
    handleReset() {
      this.standardName = "";
      this.deviceType = "";
      this.queryInspectionList();
    },
    /**
     * 每页记录数改变触发
     * @param pageSize 记录值
     */
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryInspectionList();
    },
    /**
     * 当前页改变触发
     * @param pageNo 当前页码
     */
    pageNoChange(pageNo) {
      this.pageNo = pageNo;
      this.queryInspectionList();
    },
    handleConfirm(param) {
      if (!param.getStandardItemList || !param.getStandardItemList.length) {
        this.$message.warning("请添加巡检项");
        return;
      }
      let result = param.getStandardItemList.every((item) => {
        return (
          (item.itemName && item.showType && item.showType == "3") ||
          (item.itemName &&
            item.showType &&
            item.showType == "2" &&
            (item.upValue || item.downValue)) ||
          (item.itemName &&
            item.showType &&
            item.upValue &&
            item.downValue &&
            (item.showType == "0" || item.showType == "1"))
        );
      });
      console.log(result);
      if (!result) {
        this.$message.warning("请填写完整的巡检项信息");
        return;
      }
      if (param.type == "add") {
        let addparam = {
          deviceType: param.standardInfo.deviceType,
          deviceTypeName: this.dealdeviceType(param.standardInfo.deviceType),
          // standardUuid: "",
          standardName: param.standardInfo.standardName,
          standardRemarks: param.standardInfo.standardRemarks,
        };
        this.$fetch(api.standard.addStandard, addparam).then((res) => {
          if (res.success) {
            this.dealStandItemList(
              res.data.standardId,

              param.getStandardItemList
            );
            this.$message.success("新增成功");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        let editparam = {
          deviceType: param.standardInfo.deviceType,
          deviceTypeName: this.dealdeviceType(param.standardInfo.deviceType),
          standardName: param.standardInfo.standardName,
          standardRemarks: param.standardInfo.standardRemarks,
          standardId: param.standardInfo.standardId,
        };
        this.$fetch(api.standard.editStandard, editparam).then((res) => {
          if (res.success) {
            this.dealStandItemList(
              param.standardInfo.standardId,
              param.getStandardItemList
            );
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      }
    },
    dealStandItemList(id, list) {
      let resultList = list.map((item) => {
        return {
          itemName: item.itemName || "",
          itemUnit: item.itemUnit || "",
          showType: item.showType || "",
          upValue: item.upValue || "",
          downValue: item.downValue || "",
          defaultValue: item.defaultValue || "",
          standardId: id,
        };
      });
      console.log("巡检项", resultList);
      let askParam = {
        list: resultList,
      };
      this.$fetch(api.standard.saveStandardItemList, askParam).then((res) => {
        if (res.success) {
          this.handleSearch();
          this.addVisible = false;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
// @import '../../../assets/style/mixin';
.meeting-manage {
  display: flex;
  flex-direction: column;

  .item-operation-icon {
    font-size: 14px;
    cursor: pointer;
    margin: 0 8px;
  }

  .meeting-footer {
    background: #fff;
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
}
</style>
